import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Avatar,
  Button,
  Tooltip,
  MenuItem,
  Stack,
  ListItemButton,
  ListItemText,
  Collapse,
  List
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import {
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where
} from 'firebase/firestore'
import communityLogo from '../Icons/logoAlt.png'
import {
  ExpandLess,
  ExpandMore,
  Login,
  Search,
  Person
} from '@mui/icons-material'
import '../Style/Layout.css'
import Footer from './Support/Footer'

const Layout = ({
  auth,
  setUid,
  uid,
  db,
  setUserType,
  savedLocation,
  setSavedLocation,
  setDisplayName,
  setEmail,
  overrideLocation,
  setOverrideLocation,
  dark,
  setDark
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location

  const normalPages = { Search: '/search' }
  const paidUserPages = {
    Dashboard: '/dashboard',
    Upload: {
      Document: '/upload',
      Pulse: '/uploadPulse'
    },
    Search: '/search'
  }
  const superAdminPages = {
    ADMIN: '/admin'
  }

  const [pages, setPages] = useState(normalPages)
  const [anchorElNav, setAnchorElNav] = useState(null)
  const [anchorUploadNav, setAnchorUploadNav] = useState(null)
  const [uploadOpen, setUploadOpen] = useState(false)
  const scrollRef = useRef()
  const boxRef = useRef()

  const handleUploadOpen = event => {
    setUploadOpen(!uploadOpen)
    if (typeof event !== 'undefined') {
      setAnchorUploadNav(event.currentTarget)
    }
  }

  const handleOpenNavMenu = event => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const navigateTo = page => {
    if (uid) {
      handleCloseNavMenu()
      navigate(page)
    }
  }

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' })
    switch (pathname) {
      case '/dashboard':
        document.title = 'Community Document: Dashboard'
        break
      case '/search':
        document.title = 'Community Document: Search'
        break
      case '/upload':
        document.title = 'Community Document: Upload'
        break
      case '/uploadPulse':
        document.title = 'Community Document: Upload Pulse'
        break
      case '/edit':
        document.title = 'Community Document: Edit'
        break
      case '/editPulse':
        document.title = 'Community Document: Edit Pulse'
        break
      default:
        document.title = 'Community Document'
    }
  }, [pathname])

  const logoClick = () => {
    if (uid && Object.keys(pages).length > 0) {
      if (pages['Dashboard']) {
        navigate(pages['Dashboard'])
      } else {
        navigate('/search')
      }
    } else {
      if (!uid) {
        navigate('/signup')
      }
    }
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async user => {
      if (user === null) {
        if (pathname.includes('/view')) {
          let documentType = 'documents'
          if (pathname.includes('/viewPulse')) {
            documentType = 'sliders'
          }
          var result = pathname.substring(pathname.lastIndexOf('/') + 1)
          const docRef = doc(db, documentType, result)
          const docSnap = await getDoc(docRef)
          if (
            docSnap.exists() &&
            docSnap.data().signInView !== 'undefined' &&
            docSnap.data().signInView === false
          ) {
          } else {
            let q1 = query(
              collection(db, documentType),
              where('customRoute', '==', result)
            )
            const querySnapshot = await getDocs(q1)
            if (querySnapshot.docs.length === 0) {
              if (location.key === 'default') {
                setSavedLocation(overrideLocation || window.location.pathname)
              } else {
                Object.keys(pages).length > 0 && setSavedLocation('/search')
              }
              setTimeout(() => {
                navigate('/signup')
              }, 1000)
            } else {
              querySnapshot.forEach(docSnap2 => {
                if (
                  !(
                    docSnap2.data().signInView !== 'undefined' &&
                    docSnap2.data().signInView === false
                  )
                ) {
                  if (location.key === 'default') {
                    setSavedLocation(
                      overrideLocation || window.location.pathname
                    )
                  } else {
                    Object.keys(pages).length > 0 && setSavedLocation('/search')
                  }
                  setTimeout(() => {
                    navigate('/signup')
                  }, 1000)
                }
              })
            }
          }
        } else if (pathname.includes('/support/')) {
        } else if (
          !pathname.includes('/signup') &&
          !pathname.includes('/signUp') &&
          !pathname.includes('/signin')
        ) {
          if (location.key === 'default') {
            setSavedLocation(overrideLocation || window.location.pathname)
          } else {
            Object.keys(pages).length > 0 && setSavedLocation('/search')
          }
          navigate('/signup')
        }
        setPages(normalPages)
        setUid(null)
      } else {
        setUid(user.uid)
        let docRef = doc(db, 'users', user.uid)
        let goTo = 'search'
        let email = ''
        let paid = false
        let docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          let data = docSnap.data()
          setUserType(data.paid)
          setDisplayName(data.displayName)
          if (data.paid) {
            if (data.superAdmin) {
              setPages({ ...paidUserPages, ...superAdminPages })
            } else {
              setPages(paidUserPages)
            }
            goTo = 'dashboard'
            paid = data.paid
          }
          email = data.email
        } else {
          return
        }
        setEmail(email)
        //find admin obj
        if (email !== '' && paid) {
          let q1 = query(
            collection(db, 'documents'),
            where('adminEmails', 'array-contains', email)
          )
          const querySnapshot = await getDocs(q1)
          querySnapshot.forEach(async docRef => {
            if (
              !docRef.data().admins ||
              !docRef.data().admins.includes(user.uid)
            ) {
              await setDoc(
                doc(db, 'documents', docRef.id),
                {
                  admins: arrayUnion(user.uid)
                },
                {
                  merge: true
                }
              )
              await setDoc(
                doc(db, 'users', user.uid),
                {
                  documentIds: arrayUnion(docRef.id)
                },
                {
                  merge: true
                }
              )
            }
          })

          let q2 = query(
            collection(db, 'sliders'),
            where('adminEmails', 'array-contains', email)
          )
          const querySnapshot2 = await getDocs(q2)
          querySnapshot2.forEach(async docRef => {
            if (
              !docRef.data().admins ||
              !docRef.data().admins.includes(user.uid)
            ) {
              await setDoc(
                doc(db, 'sliders', docRef.id),
                {
                  admins: arrayUnion(user.uid)
                },
                {
                  merge: true
                }
              )
              await setDoc(
                doc(db, 'users', user.uid),
                {
                  pulseIds: arrayUnion(docRef.id)
                },
                {
                  merge: true
                }
              )
            }
          })
        }

        if (
          !pathname.includes('/dashboard') &&
          !pathname.includes('/upload') &&
          !pathname.includes('/view') &&
          !pathname.includes('/search') &&
          !pathname.includes('/profile') &&
          !pathname.includes('/edit') &&
          !pathname.includes('/support/') &&
          !pathname.includes('/draft') &&
          !pathname.includes('/copy')
        ) {
          if (savedLocation) {
            navigate(savedLocation)
            Object.keys(pages).length > 0 &&
              setSavedLocation(overrideLocation || '/search')
          } else {
            navigate('/' + goTo)
          }
        }
      }

      if (window !== window.parent) {
        setPages({})
        setOverrideLocation(window.location.pathname)
      }
    })

    return unsubscribe
  }, [])

  const [scrollTop, setScrollTop] = useState(0)
  const handleScroll = () => {
    if (boxRef.current) {
      setScrollTop(boxRef.current.scrollTop)
    }
  }

  useEffect(() => {
    const scrollElement = boxRef.current
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll)
      return () => {
        scrollElement.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  return (
    <>
      <AppBar
        position='sticky'
        sx={{
          top: '16px',
          display: { xs: scrollTop < 88 ? 'flex' : 'none', md: 'flex' },
          borderRadius: '8px',
          m: { md: 2, xs: '2px 8px 8px 8px' },
          width: 'auto',
          boxShadow:
            '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)'
        }}
      >
        <Box>
          <Toolbar sx={{ paddingInlineStart: '0px !important' }}>
            <Box
              sx={{
                display: { xs: 'none', md: 'block' },
                height: '75px',
                mr: '10px'
              }}
            >
              <img
                onClick={logoClick}
                alt='logo'
                src={communityLogo}
                style={{
                  maxWidth: '100%',
                  objectFit: 'contain',
                  height: '60px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  margin: '8px'
                }}
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              {uid !== null && (
                <>
                  {Object.keys(pages).length === 1 ? (
                    <IconButton
                      size='large'
                      aria-label='Navigate to Search'
                      onClick={() => navigateTo('/search')}
                      color='inherit'
                    >
                      <Search />
                    </IconButton>
                  ) : (
                    <>
                      <IconButton
                        size='large'
                        aria-label='Menu Opener'
                        aria-controls='menu-appbar'
                        aria-haspopup='true'
                        onClick={handleOpenNavMenu}
                        color='inherit'
                        sx={{
                          display:
                            Object.keys(pages).length > 0
                              ? 'inline-flex'
                              : 'none'
                        }}
                      >
                        <MenuIcon />
                      </IconButton>
                      <Menu
                        id='menu-appbar'
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left'
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left'
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                          display: {
                            xs:
                              Object.keys(pages).length > 0 ? 'block' : 'none',
                            md: 'none'
                          }
                        }}
                      >
                        {Object.keys(pages).map(key =>
                          key === 'Upload' ? (
                            <div key={key}>
                              <ListItemButton
                                onClick={handleUploadOpen}
                                selected={
                                  !uploadOpen &&
                                  Object.keys(pages[key]).filter(
                                    subKey =>
                                      pathname.toLowerCase() ===
                                      pages[key][subKey].toLowerCase()
                                  ).length > 0
                                }
                              >
                                <ListItemText primary={key} />
                                {uploadOpen ? <ExpandLess /> : <ExpandMore />}
                              </ListItemButton>
                              <Collapse
                                in={uploadOpen}
                                timeout='auto'
                                unmountOnExit
                              >
                                <List component='div' disablePadding>
                                  {Object.keys(pages[key]).map(subKey => (
                                    <ListItemButton
                                      key={subKey}
                                      sx={{ pl: 4 }}
                                      selected={
                                        pathname.toLowerCase() ===
                                        pages[key][subKey].toLowerCase()
                                      }
                                      onClick={() =>
                                        navigateTo(pages[key][subKey])
                                      }
                                    >
                                      <ListItemText primary={subKey} />
                                    </ListItemButton>
                                  ))}
                                </List>
                              </Collapse>
                            </div>
                          ) : (
                            <ListItemButton
                              key={key}
                              onClick={() => navigateTo(pages[key])}
                              selected={
                                pathname.toLowerCase() ===
                                pages[key].toLowerCase()
                              }
                            >
                              <ListItemText primary={key} />
                            </ListItemButton>
                          )
                        )}
                      </Menu>
                    </>
                  )}
                </>
              )}
            </Box>
            <Box
              sx={{
                display: { xs: 'block', md: 'none' },
                flexGrow: 1,
                height: '5vh'
              }}
            >
              <img
                onClick={logoClick}
                alt='logo'
                src={communityLogo}
                style={{
                  maxWidth: '100%',
                  objectFit: 'contain',
                  height: '5vh',
                  cursor: 'pointer',
                  borderRadius: '4px'
                }}
              />
            </Box>
            {uid !== null ? (
              <>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    gap: 1
                  }}
                >
                  {Object.keys(pages).map(key =>
                    key === 'Upload' ? (
                      <div key={key}>
                        <Button
                          id='demo-customized-button'
                          aria-controls={
                            uploadOpen ? 'demo-customized-menu' : undefined
                          }
                          aria-haspopup='true'
                          aria-expanded={uploadOpen ? 'true' : undefined}
                          onClick={handleUploadOpen}
                          endIcon={<ExpandMore />}
                          sx={{ my: 2, color: 'white' }}
                          className={
                            !uploadOpen &&
                            Object.keys(pages[key]).filter(
                              subKey =>
                                pathname.toLowerCase() ===
                                pages[key][subKey].toLowerCase()
                            ).length > 0
                              ? 'selectedPage'
                              : ''
                          }
                        >
                          {key}
                        </Button>
                        <Menu
                          sx={{
                            display: { xs: 'none', md: 'block' }
                          }}
                          id='demo-customized-menu'
                          MenuListProps={{
                            'aria-labelledby': 'demo-customized-button'
                          }}
                          anchorEl={anchorUploadNav}
                          open={uploadOpen}
                          onClose={handleUploadOpen}
                        >
                          {Object.keys(pages[key]).map(subKey => (
                            <MenuItem
                              key={subKey}
                              onClick={() => {
                                handleUploadOpen(undefined)
                                navigateTo(pages[key][subKey])
                              }}
                              disableRipple
                              selected={
                                pathname.toLowerCase() ===
                                pages[key][subKey].toLowerCase()
                              }
                            >
                              {subKey}
                            </MenuItem>
                          ))}
                        </Menu>
                      </div>
                    ) : (
                      <Button
                        key={key}
                        onClick={() => navigateTo(pages[key])}
                        sx={{ my: 2, color: 'white', display: 'block' }}
                        className={
                          pathname.toLowerCase() === pages[key].toLowerCase()
                            ? 'selectedPage'
                            : ''
                        }
                      >
                        {key}
                      </Button>
                    )
                  )}
                </Box>

                <Box sx={{ flexGrow: 0 }}>
                  <Tooltip title='Open Profile'>
                    <IconButton
                      onClick={() => {
                        navigateTo('/profile')
                      }}
                      sx={{ p: 0 }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: 'transparent',
                          color: 'white'
                        }}
                        alt='Profile'
                      >
                        <Person />
                      </Avatar>
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            ) : (
              <Stack direction='row' spacing={2} sx={{ ml: 'auto' }}>
                <Button
                  onClick={() => navigate('/support/about')}
                  sx={{
                    my: 2,
                    color: 'white',
                    display: { xs: 'none', md: 'block' }
                  }}
                >
                  About
                </Button>
                <Button
                  onClick={() => navigate('/support/contact')}
                  sx={{
                    my: 2,
                    color: 'white',
                    display: { xs: 'none', md: 'block' }
                  }}
                >
                  Contact Us
                </Button>
                <Button
                  onClick={() => {
                    setSavedLocation(
                      overrideLocation || window.location.pathname
                    )
                    navigate('/signup')
                  }}
                  sx={{
                    my: 2,
                    color: 'white',
                    display: { xs: 'none', md: 'block' }
                  }}
                >
                  Sign Up
                </Button>
                <IconButton
                  onClick={() => {
                    setSavedLocation(
                      overrideLocation || window.location.pathname
                    )
                    navigate('/signup')
                  }}
                  sx={{ my: 2, display: { xs: 'block', md: 'none' } }}
                >
                  <Login sx={{ fill: 'white' }} />
                </IconButton>
              </Stack>
            )}
          </Toolbar>
        </Box>
      </AppBar>
      <Box
        sx={{
          overflowY: 'auto',
          height: 'calc(100vh - 88px)'
        }}
        ref={boxRef}
      >
        <div ref={scrollRef} style={{ marginTop: -3 }} />
        <Box sx={{ minHeight: { md: '85%', xs: '100%' } }}>
          <Outlet />
        </Box>
        <Footer dark={dark} setDark={setDark} />
      </Box>
    </>
  )
}

export default Layout
